module.exports = __webpack_public_path__ + "static/assets/3dfc8d5cdedb3e5e2a737e346bab51f8.png";